import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_PHARMAKON_PAYMENT_CARD_LIST } from 'src/app/hooks/data/_keys';
import { useBffClient } from 'src/app/hooks/data/useBffClient';
import type { PaymentCard } from 'src/app/types/account';

export const usePaymentCardListByAccountId = (
  accountId: number,
  { enabled }: { enabled?: boolean }
): UseQueryResult<PaymentCard[], AxiosError> => {
  const authClient = useBffClient();

  return useQuery(
    [CACHE_KEY_PHARMAKON_PAYMENT_CARD_LIST, accountId],
    () => authClient.get(`accounts/${accountId}/payment_methods`).then((resp: { data: PaymentCard[] }) => resp.data),
    {
      ...(enabled !== undefined && { enabled }),
    }
  );
};

export const usePaymentCardDelete = (accountId: number): UseMutationResult<void, AxiosError, number> => {
  const authClient = useBffClient();
  const queryClient = useQueryClient();

  return useMutation(
    (
      id // Payment card ID.
    ) => authClient.delete(`accounts/${accountId}/payment_methods/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([CACHE_KEY_PHARMAKON_PAYMENT_CARD_LIST]);
      },
    }
  );
};
